var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { html, LitElement } from 'lit';
import { property, query } from 'lit/decorators.js';
import { isEmpty, isNil } from 'lodash-es';
import { translate } from '../utilities/translate';
import styles from './sds-paginator.lit.scss';
import { sdsCustomElement } from '../utilities/custom-components';
/**
 * `sds-paginator` provides pagination controls for navigating through items in a list or dataset.
 *
 * ### Attributes
 * - `length`: Specifies the total number of items (full mode).
 * - `simple`: Enables simple pagination mode without total count.
 * - `current-page-length`: Number of items in current page for next page determination.
 * - `hide-items-per-page`: Toggles visibility of the items-per-page dropdown.
 * - `items-per-page`: Sets selectable options for items per page.
 * - `default-page-size`: Defines the default number of items displayed per page.
 * - `page-size`: Controls the current page size.
 * - `hide-edge-buttons`: Toggles visibility of navigation buttons for first and last pages.
 * - `page-index`: Specifies the current page index.
 *
 * ### Examples
 * ```html
 * <!-- Simple mode -->
 * <sds-paginator simple current-page-length="10"></sds-paginator>
 *
 * <!-- Full mode -->
 * <sds-paginator length="1000"></sds-paginator>
 * ```
 *
 * @tag sds-paginator
 */
let SdsPaginator = (() => {
    var _SdsPaginator_length_accessor_storage, _SdsPaginator_hideItemsPerPage_accessor_storage, _SdsPaginator_currentPageLength_accessor_storage, _SdsPaginator_simple_accessor_storage, _SdsPaginator_itemsPerPage_accessor_storage, _SdsPaginator_defaultPageSize_accessor_storage, _SdsPaginator_pageSize_accessor_storage, _SdsPaginator_hideEdgeButtons_accessor_storage, _SdsPaginator_currentPageIndex_accessor_storage, _SdsPaginator__pageSizeSelect_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-paginator')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _length_decorators;
    let _length_initializers = [];
    let _length_extraInitializers = [];
    let _hideItemsPerPage_decorators;
    let _hideItemsPerPage_initializers = [];
    let _hideItemsPerPage_extraInitializers = [];
    let _currentPageLength_decorators;
    let _currentPageLength_initializers = [];
    let _currentPageLength_extraInitializers = [];
    let _simple_decorators;
    let _simple_initializers = [];
    let _simple_extraInitializers = [];
    let _itemsPerPage_decorators;
    let _itemsPerPage_initializers = [];
    let _itemsPerPage_extraInitializers = [];
    let _defaultPageSize_decorators;
    let _defaultPageSize_initializers = [];
    let _defaultPageSize_extraInitializers = [];
    let _pageSize_decorators;
    let _pageSize_initializers = [];
    let _pageSize_extraInitializers = [];
    let _hideEdgeButtons_decorators;
    let _hideEdgeButtons_initializers = [];
    let _hideEdgeButtons_extraInitializers = [];
    let _currentPageIndex_decorators;
    let _currentPageIndex_initializers = [];
    let _currentPageIndex_extraInitializers = [];
    let __pageSizeSelect_decorators;
    let __pageSizeSelect_initializers = [];
    let __pageSizeSelect_extraInitializers = [];
    var SdsPaginator = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsPaginator_length_accessor_storage.set(this, __runInitializers(this, _length_initializers, void 0));
            _SdsPaginator_hideItemsPerPage_accessor_storage.set(this, (__runInitializers(this, _length_extraInitializers), __runInitializers(this, _hideItemsPerPage_initializers, false)));
            _SdsPaginator_currentPageLength_accessor_storage.set(this, (__runInitializers(this, _hideItemsPerPage_extraInitializers), __runInitializers(this, _currentPageLength_initializers, void 0)));
            _SdsPaginator_simple_accessor_storage.set(this, (__runInitializers(this, _currentPageLength_extraInitializers), __runInitializers(this, _simple_initializers, false)));
            _SdsPaginator_itemsPerPage_accessor_storage.set(this, (__runInitializers(this, _simple_extraInitializers), __runInitializers(this, _itemsPerPage_initializers, void 0)));
            _SdsPaginator_defaultPageSize_accessor_storage.set(this, (__runInitializers(this, _itemsPerPage_extraInitializers), __runInitializers(this, _defaultPageSize_initializers, void 0)));
            _SdsPaginator_pageSize_accessor_storage.set(this, (__runInitializers(this, _defaultPageSize_extraInitializers), __runInitializers(this, _pageSize_initializers, 10)));
            _SdsPaginator_hideEdgeButtons_accessor_storage.set(this, (__runInitializers(this, _pageSize_extraInitializers), __runInitializers(this, _hideEdgeButtons_initializers, false)));
            _SdsPaginator_currentPageIndex_accessor_storage.set(this, (__runInitializers(this, _hideEdgeButtons_extraInitializers), __runInitializers(this, _currentPageIndex_initializers, 1)));
            this._currentPageSizeIndex = (__runInitializers(this, _currentPageIndex_extraInitializers), 0);
            _SdsPaginator__pageSizeSelect_accessor_storage.set(this, __runInitializers(this, __pageSizeSelect_initializers, void 0));
            this._numberOfPages = __runInitializers(this, __pageSizeSelect_extraInitializers);
        }
        /**
         * Specifies the total number of items to paginate through.
         *
         * @attr {number} length - Total count of items.
         */
        get length() { return __classPrivateFieldGet(this, _SdsPaginator_length_accessor_storage, "f"); }
        set length(value) { __classPrivateFieldSet(this, _SdsPaginator_length_accessor_storage, value, "f"); }
        /**
         * Toggles the visibility of the items-per-page dropdown menu.
         *
         * @attr {boolean} hide-items-per-page - If `true`, the items-per-page dropdown is hidden. Defaults to `false`.
         */
        get hideItemsPerPage() { return __classPrivateFieldGet(this, _SdsPaginator_hideItemsPerPage_accessor_storage, "f"); }
        set hideItemsPerPage(value) { __classPrivateFieldSet(this, _SdsPaginator_hideItemsPerPage_accessor_storage, value, "f"); }
        /**
         * Specifies the number of items in the current page for determining next page availability.
         *
         * This property is used in simple pagination mode to determine if there are more pages.
         * If currentPageLength equals pageSize, the next button is enabled (assuming there might be more data).
         * If currentPageLength is less than pageSize, the next button is disabled (end of data).
         *
         * @attr {number} current-page-length - Number of items currently displayed on the page.
         *                                      Used to determine if next page should be available.
         */
        get currentPageLength() { return __classPrivateFieldGet(this, _SdsPaginator_currentPageLength_accessor_storage, "f"); }
        set currentPageLength(value) { __classPrivateFieldSet(this, _SdsPaginator_currentPageLength_accessor_storage, value, "f"); }
        /**
         * Enables simple pagination mode without requiring total item count.
         * When enabled, uses currentPageLength property to control next button visibility.
         *
         * @attr {boolean} simple - If `true`, enables simple pagination mode. Defaults to `false`.
         */
        get simple() { return __classPrivateFieldGet(this, _SdsPaginator_simple_accessor_storage, "f"); }
        set simple(value) { __classPrivateFieldSet(this, _SdsPaginator_simple_accessor_storage, value, "f"); }
        /**
         * Sets the options available in the items-per-page dropdown.
         *
         * @attr {Array<number>} items-per-page - List of selectable items per page.
         */
        get itemsPerPage() { return __classPrivateFieldGet(this, _SdsPaginator_itemsPerPage_accessor_storage, "f"); }
        set itemsPerPage(value) { __classPrivateFieldSet(this, _SdsPaginator_itemsPerPage_accessor_storage, value, "f"); }
        /**
         * Defines the default number of items displayed per page.
         *
         * @attr {number} default-page-size - Default number of items per page.
         */
        get defaultPageSize() { return __classPrivateFieldGet(this, _SdsPaginator_defaultPageSize_accessor_storage, "f"); }
        set defaultPageSize(value) { __classPrivateFieldSet(this, _SdsPaginator_defaultPageSize_accessor_storage, value, "f"); }
        /**
         * Controls the current number of items displayed per page.
         *
         * @attr {number} page-size - Page size for the current view. Defaults to `10`.
         */
        get pageSize() { return __classPrivateFieldGet(this, _SdsPaginator_pageSize_accessor_storage, "f"); }
        set pageSize(value) { __classPrivateFieldSet(this, _SdsPaginator_pageSize_accessor_storage, value, "f"); }
        /**
         * Toggles the visibility of the navigation buttons for the first and last pages.
         *
         * @attr {boolean} hide-edge-buttons - If `true`, the first and last page navigation buttons are hidden. Defaults to `false`.
         */
        get hideEdgeButtons() { return __classPrivateFieldGet(this, _SdsPaginator_hideEdgeButtons_accessor_storage, "f"); }
        set hideEdgeButtons(value) { __classPrivateFieldSet(this, _SdsPaginator_hideEdgeButtons_accessor_storage, value, "f"); }
        /**
         * Specifies the current page index.
         *
         * Minimum value is `1`.
         *
         * @attr {number} page-index - Current page index. Defaults to `1`.
         */
        get currentPageIndex() { return __classPrivateFieldGet(this, _SdsPaginator_currentPageIndex_accessor_storage, "f"); }
        set currentPageIndex(value) { __classPrivateFieldSet(this, _SdsPaginator_currentPageIndex_accessor_storage, value, "f"); }
        get _pageSizeSelect() { return __classPrivateFieldGet(this, _SdsPaginator__pageSizeSelect_accessor_storage, "f"); }
        set _pageSizeSelect(value) { __classPrivateFieldSet(this, _SdsPaginator__pageSizeSelect_accessor_storage, value, "f"); }
        firstUpdated(changedProperties) {
            super.firstUpdated(changedProperties);
            this.pageSize = !isNil(this.defaultPageSize)
                ? this.defaultPageSize
                : !isNil(this.itemsPerPage) && !isEmpty(this.itemsPerPage)
                    ? this.itemsPerPage[0]
                    : this.pageSize;
        }
        willUpdate(_changedProperties) {
            var _a;
            super.willUpdate(_changedProperties);
            if (_changedProperties.has('simple') ||
                _changedProperties.has('length') ||
                _changedProperties.has('currentPageLength')) {
                this.validatePaginationMode();
            }
            if (_changedProperties.has('pageSize') &&
                _changedProperties.get('pageSize') !== undefined) {
                this.pageSizeChanged();
            }
            this.initCalculations();
            (_a = this._pageSizeSelect) === null || _a === void 0 ? void 0 : _a.requestUpdate();
        }
        initCalculations() {
            this.countNumberOfPages();
            this.countFirstItemIndex();
            this.countLastItemIndex();
            this.storePageSizeOptions();
            this.setCurrentPageSizeIndex();
        }
        validatePaginationMode() {
            if (this.simple && !isNil(this.length)) {
                console.error('sds-paginator: Both "simple" and "length" properties are set. Simple mode will take precedence.');
            }
            if (!this.simple && isNil(this.length)) {
                console.error('sds-paginator: Neither "simple" mode nor "length" property is set. Component may not function correctly.');
            }
        }
        render() {
            return html `
            <div class="sds-paginator">
                ${this.renderProperties()}
                <div class="sds-paginator__nav">${this.renderInfo()} ${this.renderButtons()}</div>
            </div>
        `;
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        countNumberOfPages() {
            if (!isNil(this.length)) {
                this._numberOfPages =
                    Math.floor(this.length / this.pageSize) +
                        (this.length % this.pageSize === 0 ? 0 : 1);
            }
            else {
                this._numberOfPages = Number.MAX_SAFE_INTEGER; // Assume unlimited pages
            }
        }
        countFirstItemIndex() {
            if (this.simple || (!isNil(this.length) && this.length !== 0)) {
                this._firstItemIndex = this.pageSize * (this.currentPageIndex - 1) + 1;
            }
            else {
                this._firstItemIndex = 0;
            }
        }
        countLastItemIndex() {
            if (this.simple) {
                if (this.currentPageLength < this.pageSize) {
                    this._lastItemIndex =
                        this.pageSize * (this.currentPageIndex - 1) + this.currentPageLength;
                }
                else {
                    this._lastItemIndex = this.pageSize * this.currentPageIndex;
                }
            }
            else if (!isNil(this.length) && this.length !== 0) {
                if (this.currentPageIndex !== this._numberOfPages) {
                    this._lastItemIndex = this.pageSize * this.currentPageIndex;
                }
                else {
                    this._lastItemIndex = this.length;
                }
            }
            else {
                this._lastItemIndex = 0;
            }
        }
        storePageSizeOptions() {
            if (!isNil(this.itemsPerPage) && !isEmpty(this.itemsPerPage)) {
                this._pageSizeOptions = this.itemsPerPage;
                return;
            }
            if (this.simple) {
                this._pageSizeOptions = [10, 20, 50, 100];
            }
            else if (!isNil(this.length)) {
                if (this.length > 50) {
                    this._pageSizeOptions = [10, 20, 50, 100];
                }
                else if (this.length > 20) {
                    this._pageSizeOptions = [10, 20, 50];
                }
                else if (this.length > 10) {
                    this._pageSizeOptions = [10, 20];
                }
                else {
                    this._pageSizeOptions = [10];
                }
            }
            else {
                this._pageSizeOptions = [10];
            }
        }
        canNavigateNext() {
            if (this.simple) {
                return !isNil(this.currentPageLength) && this.currentPageLength >= this.pageSize;
            }
            return this.length > this.pageSize && this.currentPageIndex !== this._numberOfPages;
        }
        canNavigatePrevious() {
            return this.currentPageIndex > 1;
        }
        goToTheLastPage() {
            this.goToThePage(this._numberOfPages);
        }
        goToTheFirstPage() {
            this.goToThePage(1);
        }
        goToThePage(index) {
            if (this.simple) {
                if (index > 0 && this.currentPageIndex !== index) {
                    this.currentPageIndex = index;
                    this.handleChanged();
                }
            }
            else if (index > 0 && index <= this._numberOfPages && this.currentPageIndex !== index) {
                this.currentPageIndex = index;
                this.handleChanged();
            }
        }
        goToTheNextPage() {
            this.goToThePage(this.currentPageIndex + 1);
        }
        goToThePreviousPage() {
            this.goToThePage(this.currentPageIndex - 1);
        }
        pageSizeChangedHandler(identifier) {
            this.pageSize = Number(identifier);
            const pageSizeChanged = new CustomEvent(SdsPaginator.CHANGE_PAGE_SIZE_EVENT, {
                detail: {
                    currentPage: this.currentPageIndex,
                    pageSize: this.pageSize,
                },
                bubbles: false,
                composed: false,
            });
            this.dispatchEvent(pageSizeChanged);
        }
        pageSizeChanged() {
            this.countNumberOfPages();
            this.currentPageIndex = 1;
            this.handleChanged();
        }
        setCurrentPageSizeIndex() {
            this._currentPageSizeIndex = this._pageSizeOptions.indexOf(this.pageSize);
        }
        handleChanged() {
            const changed = new CustomEvent(SdsPaginator.CHANGE_EVENT, {
                detail: {
                    currentPage: this.currentPageIndex,
                    pageSize: this.pageSize,
                },
                bubbles: false,
                composed: false,
            });
            this.dispatchEvent(changed);
        }
        renderProperties() {
            if (!this.hideItemsPerPage) {
                return html `
                <div class="sds-paginator__options">
                    ${translate('common.items-per-page.label')}
                    <sds-select
                        id="page-size-select"
                        @sds.select.selected="${(event) => this.pageSizeChangedHandler(event.detail.identifier)}"
                        ?disabled="${!this.simple && this.length <= this._pageSizeOptions[0]}"
                        pagination
                    >
                        ${this._pageSizeOptions.map((element, index) => html `<sds-cm-select-item
                                    ?selected="${index === this._currentPageSizeIndex}"
                                    name="${element}"
                                    identifier="${element}"
                                ></sds-cm-select-item>`)}
                    </sds-select>
                </div>
            `;
            }
        }
        renderInfo() {
            return this.simple ? this.renderInfoSimple() : this.renderInfoFull();
        }
        renderInfoSimple() {
            return html `
            <div class="sds-paginator__info">
                <strong>${this._firstItemIndex} - ${this._lastItemIndex}</strong>
            </div>
        `;
        }
        renderInfoFull() {
            return html `
            <div class="sds-paginator__info">
                <strong>${this._firstItemIndex} - ${this._lastItemIndex} </strong>
                <bdi>${translate('sds.from')}</bdi>
                ${this.length}
            </div>
        `;
        }
        renderButtons() {
            return html `
            <div class="sds-paginator__buttons">
                ${this.renderGoToFirstButton()} ${this.renderGoToPreviousButton()}
                ${this.renderGoToNextButton()} ${this.renderGoToLastButton()}
            </div>
        `;
        }
        renderGoToFirstButton() {
            if (!this.hideEdgeButtons && !this.simple) {
                return html `
                <sds-button-icon
                    type="primary"
                    icon="arrow_go_to_start_thin"
                    size="lg"
                    ?disabled="${!this.canNavigatePrevious()}"
                    @click="${() => this.goToTheFirstPage()}"
                ></sds-button-icon>
            `;
            }
        }
        renderGoToPreviousButton() {
            return html `
            <sds-button-icon
                type="primary"
                icon="arrow_left_thin"
                size="lg"
                ?disabled="${!this.canNavigatePrevious()}"
                @click="${() => this.goToThePreviousPage()}"
            ></sds-button-icon>
        `;
        }
        renderGoToNextButton() {
            return html `
            <sds-button-icon
                type="primary"
                icon="arrow_right_thin"
                size="lg"
                ?disabled="${!this.canNavigateNext()}"
                @click="${() => this.goToTheNextPage()}"
            ></sds-button-icon>
        `;
        }
        renderGoToLastButton() {
            if (!this.hideEdgeButtons && !this.simple) {
                return html `
                <sds-button-icon
                    type="primary"
                    icon="arrow_go_to_end_thin"
                    size="lg"
                    ?disabled="${!this.canNavigateNext()}"
                    @click="${() => this.goToTheLastPage()}"
                ></sds-button-icon>
            `;
            }
        }
    };
    _SdsPaginator_length_accessor_storage = new WeakMap();
    _SdsPaginator_hideItemsPerPage_accessor_storage = new WeakMap();
    _SdsPaginator_currentPageLength_accessor_storage = new WeakMap();
    _SdsPaginator_simple_accessor_storage = new WeakMap();
    _SdsPaginator_itemsPerPage_accessor_storage = new WeakMap();
    _SdsPaginator_defaultPageSize_accessor_storage = new WeakMap();
    _SdsPaginator_pageSize_accessor_storage = new WeakMap();
    _SdsPaginator_hideEdgeButtons_accessor_storage = new WeakMap();
    _SdsPaginator_currentPageIndex_accessor_storage = new WeakMap();
    _SdsPaginator__pageSizeSelect_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsPaginator");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _length_decorators = [property({ type: Number })];
        _hideItemsPerPage_decorators = [property({ type: Boolean, attribute: 'hide-items-per-page' })];
        _currentPageLength_decorators = [property({ type: Number, attribute: 'current-page-length' })];
        _simple_decorators = [property({ type: Boolean })];
        _itemsPerPage_decorators = [property({ type: (Array), attribute: 'items-per-page' })];
        _defaultPageSize_decorators = [property({ type: Number, attribute: 'default-page-size' })];
        _pageSize_decorators = [property({ type: Number, attribute: 'page-size', reflect: true })];
        _hideEdgeButtons_decorators = [property({ type: Boolean, attribute: 'hide-edge-buttons' })];
        _currentPageIndex_decorators = [property({ type: Number, attribute: 'page-index', reflect: true })];
        __pageSizeSelect_decorators = [query('#page-size-select')];
        __esDecorate(_classThis, null, _length_decorators, { kind: "accessor", name: "length", static: false, private: false, access: { has: obj => "length" in obj, get: obj => obj.length, set: (obj, value) => { obj.length = value; } }, metadata: _metadata }, _length_initializers, _length_extraInitializers);
        __esDecorate(_classThis, null, _hideItemsPerPage_decorators, { kind: "accessor", name: "hideItemsPerPage", static: false, private: false, access: { has: obj => "hideItemsPerPage" in obj, get: obj => obj.hideItemsPerPage, set: (obj, value) => { obj.hideItemsPerPage = value; } }, metadata: _metadata }, _hideItemsPerPage_initializers, _hideItemsPerPage_extraInitializers);
        __esDecorate(_classThis, null, _currentPageLength_decorators, { kind: "accessor", name: "currentPageLength", static: false, private: false, access: { has: obj => "currentPageLength" in obj, get: obj => obj.currentPageLength, set: (obj, value) => { obj.currentPageLength = value; } }, metadata: _metadata }, _currentPageLength_initializers, _currentPageLength_extraInitializers);
        __esDecorate(_classThis, null, _simple_decorators, { kind: "accessor", name: "simple", static: false, private: false, access: { has: obj => "simple" in obj, get: obj => obj.simple, set: (obj, value) => { obj.simple = value; } }, metadata: _metadata }, _simple_initializers, _simple_extraInitializers);
        __esDecorate(_classThis, null, _itemsPerPage_decorators, { kind: "accessor", name: "itemsPerPage", static: false, private: false, access: { has: obj => "itemsPerPage" in obj, get: obj => obj.itemsPerPage, set: (obj, value) => { obj.itemsPerPage = value; } }, metadata: _metadata }, _itemsPerPage_initializers, _itemsPerPage_extraInitializers);
        __esDecorate(_classThis, null, _defaultPageSize_decorators, { kind: "accessor", name: "defaultPageSize", static: false, private: false, access: { has: obj => "defaultPageSize" in obj, get: obj => obj.defaultPageSize, set: (obj, value) => { obj.defaultPageSize = value; } }, metadata: _metadata }, _defaultPageSize_initializers, _defaultPageSize_extraInitializers);
        __esDecorate(_classThis, null, _pageSize_decorators, { kind: "accessor", name: "pageSize", static: false, private: false, access: { has: obj => "pageSize" in obj, get: obj => obj.pageSize, set: (obj, value) => { obj.pageSize = value; } }, metadata: _metadata }, _pageSize_initializers, _pageSize_extraInitializers);
        __esDecorate(_classThis, null, _hideEdgeButtons_decorators, { kind: "accessor", name: "hideEdgeButtons", static: false, private: false, access: { has: obj => "hideEdgeButtons" in obj, get: obj => obj.hideEdgeButtons, set: (obj, value) => { obj.hideEdgeButtons = value; } }, metadata: _metadata }, _hideEdgeButtons_initializers, _hideEdgeButtons_extraInitializers);
        __esDecorate(_classThis, null, _currentPageIndex_decorators, { kind: "accessor", name: "currentPageIndex", static: false, private: false, access: { has: obj => "currentPageIndex" in obj, get: obj => obj.currentPageIndex, set: (obj, value) => { obj.currentPageIndex = value; } }, metadata: _metadata }, _currentPageIndex_initializers, _currentPageIndex_extraInitializers);
        __esDecorate(_classThis, null, __pageSizeSelect_decorators, { kind: "accessor", name: "_pageSizeSelect", static: false, private: false, access: { has: obj => "_pageSizeSelect" in obj, get: obj => obj._pageSizeSelect, set: (obj, value) => { obj._pageSizeSelect = value; } }, metadata: _metadata }, __pageSizeSelect_initializers, __pageSizeSelect_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsPaginator = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.CHANGE_EVENT = 'sds.page.changed';
    _classThis.CHANGE_PAGE_SIZE_EVENT = 'sds.page.size.changed';
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsPaginator = _classThis;
})();
export { SdsPaginator };
